import { render } from "./WordListMemoryContent.vue?vue&type=template&id=4ca790e6&scoped=true"
import script from "./WordListMemoryContent.vue?vue&type=script&lang=js"
export * from "./WordListMemoryContent.vue?vue&type=script&lang=js"

import "./WordListMemoryContent.vue?vue&type=style&index=0&id=4ca790e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca790e6"]])

export default __exports__